import { Link } from 'gatsby'
import React from 'react'
import { Row, Col } from "react-bootstrap";

import { PageLinks } from '../../../common/site/page-static-links'
// import pluralize from 'pluralize'

const ResidentialPopularSearch = ({ popularSearchObject, showPopular }) => {
    let {
        searchType,
        action,
        area,
        postcode,
        department,
        propertyType,
        bedrooms,
        minprice,
        maxprice
    } = popularSearchObject

    const defaultAreas = [
        { slug: "cornwall", label: "Cornwall" },
        { slug: "devon", label: "Devon" },
        { slug: "somerset", label: "Somerset" },
        { slug: "dorset", label: "Dorset" },
    ]

    // string capitalize
    function capitalize(value) {
        let capStr = value.charAt(0).toUpperCase() + value.slice(1)
        capStr = capStr.replace("-", " ")
        return capStr
    }

    // array capitalize
    function capitalizeWords(arr) {
        return arr.map((word) => {
            const capitalizedFirst = word.charAt(0).toUpperCase();
            const rest = word.slice(1).replaceAll("-", " ").toLowerCase();
            return capitalizedFirst + rest;
        });
    }

    let actionText = "";
    let url = "";
    let typeText = "property"
    let areaUrl = ""
    let areaText = ""
    let lastcolumnareaText = ""
    let bedroomUrl = ""
    let propertyTypeUrl = ""
    let propertyTypeText = ""

    //if(department === "commercial")

    if (searchType === "sales") {
        actionText = "for sale"
        url = "properties/for-sale"
    } else {
        actionText = "to rent"
        url = "properties/to-rent"
    }

    if (area) {
        if (typeof area === "object") {
            let CapitalizeArea = capitalizeWords(area)
            areaUrl = area.join("-and-")
            areaText = CapitalizeArea.join(" and ")
            lastcolumnareaText = CapitalizeArea.join(" and ")
        } else {
            areaUrl = area.replaceAll(" ", "-")
            areaText = capitalize(area)
            lastcolumnareaText = capitalize(area)
        }
        areaUrl = `in-${areaUrl}`
        areaText = `in ${capitalize(areaText)}`
    }

    // if (postcode) {
    //     areaUrl = `in-${postcode}`
    //     areaText = `in ${postcode.toUpperCase()}`
    //     lastcolumnareaText = postcode.toUpperCase()
    // }

    if (bedrooms) {
        bedroomUrl =
            bedrooms === "1"
                ? `${bedrooms}-bedroom`
                : `${bedrooms}-bedrooms`
    }

    if (propertyType) {
        propertyTypeUrl = `type-${propertyType}`
        propertyTypeText = propertyType.replace("-", "")
        propertyTypeText = propertyTypeText
    }

    return (
        <div className={`row`}>
            <Col xl={3}>
                {
                    (bedrooms && propertyType) ?
                        <ul className='list-unstyled popular-searches-list'>
                            {defaultAreas.map((area, k) => {
                                return (
                                    <li key={k}><a href={`/${url}/in-${area.slug}/${propertyTypeUrl}/${bedroomUrl}/`}>{bedrooms} bedroom {propertyType.replace("-", "")} {actionText} in {area.label}</a></li>
                                )
                            })}
                        </ul>
                        :
                        (bedrooms || (bedrooms && (minprice || maxprice))) ?
                            <ul className='list-unstyled popular-searches-list'>
                                {defaultAreas.map((area, k) => {
                                    return (
                                        <li key={k}><a href={`/${url}/in-${area.slug}/radius-3-miles/${bedroomUrl}/`}>{bedrooms} bedroom property {actionText} in {area.label}</a></li>
                                    )
                                })}
                            </ul>
                            :
                            (propertyType || (propertyType && (minprice || maxprice))) ?
                                <ul className='list-unstyled popular-searches-list'>
                                    {defaultAreas.map((area, k) => {
                                        return (
                                            <li key={k}><a href={`/${url}/in-${area.slug}/radius-3-miles/${propertyTypeUrl}/`}>{capitalize(propertyTypeText)} {actionText} in {area.label}</a></li>
                                        )
                                    })}
                                </ul>
                                :
                                <ul className='list-unstyled popular-searches-list'>
                                    {defaultAreas.map((area, k) => {
                                        return (
                                            <li key={k}><a href={`/${url}/in-${area.slug}/radius-3-miles/`}>{capitalize(typeText)} {actionText} in {area.label}</a></li>
                                        )
                                    })}
                                </ul>
                }
            </Col>
            <Col xl={3}>
                {
                    (bedrooms && propertyType) ?
                        <ul className='list-unstyled popular-searches-list'> 
                            {defaultAreas.map((area, k) => {
                                return (
                                    <li key={k}><a href={`/${url}/in-${area.slug}/radius-3-miles/${propertyTypeUrl}/`}>{capitalize(propertyType)} {actionText} in {area.label}</a></li>
                                )
                            })}
                        </ul>
                        :
                        (propertyType || (propertyType && (minprice || maxprice))) ?
                            <ul className='list-unstyled popular-searches-list'>
                                <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}${propertyTypeUrl}/1-and-more-bedrooms/`}>1 bedroom {propertyTypeText} {actionText} {areaText}</a></li>
                                <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}${propertyTypeUrl}/2-and-more-bedrooms/`}>2 bedrooms {propertyTypeText} {actionText} {areaText}</a></li>
                                <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}${propertyTypeUrl}/4-and-more-bedrooms/`}>4 bedrooms {propertyTypeText} {actionText} {areaText}</a></li>
                                <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}${propertyTypeUrl}/5-and-more-bedrooms/`}>5 bedrooms {propertyTypeText} {actionText} {areaText}</a></li>
                            </ul>
                            :

                            <ul className='list-unstyled popular-searches-list'>
                                <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}1-and-more-bedrooms/`}>1 bedroom {typeText} {actionText} {areaText}</a></li>
                                <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}2-and-more-bedrooms/`}>2 bedrooms {typeText} {actionText} {areaText}</a></li>
                                <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}4-and-more-bedrooms/`}>4 bedrooms {typeText} {actionText} {areaText}</a></li>
                                <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}5-and-more-bedrooms/`}>5 bedrooms {typeText} {actionText} {areaText}</a></li>
                            </ul>
                }
            </Col>
            <Col xl={3}>
                {
                    (bedrooms && propertyType) ?
                        <ul className='list-unstyled popular-searches-list'>
                            <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}1-and-more-bedrooms/`}>1 bedroom {typeText} {actionText} {areaText}</a></li>
                            <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}2-and-more-bedrooms/`}>2 bedrooms {typeText} {actionText} {areaText}</a></li>
                            <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}4-and-more-bedrooms/`}>4 bedrooms {typeText} {actionText} {areaText}</a></li>
                            <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}5-and-more-bedrooms/`}>5 bedrooms {typeText} {actionText} {areaText}</a></li>
                        </ul>
                        :
                        <ul className='list-unstyled popular-searches-list'>
                            <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}`}>Property {actionText} {areaText}</a></li>
                            <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}type-house/`}>Houses {actionText} {areaText}</a></li>
                            <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}type-apartment/`}>Apartments {actionText} {areaText}</a></li>
                            <li><a href={`/${url}/${areaUrl ? areaUrl + "/" : ""}type-bungalow/`}>Bungalows {actionText} {areaText}</a></li>
                        </ul>
                }
            </Col>
            <Col xl={3}>

                <ul className='list-unstyled popular-searches-list'>
                    <li><a href={`/${PageLinks.contact}/`}>Estate agents {areaText}</a></li>
                    <li><a href={`/${PageLinks.enquiry}/`}>Letting agents in {areaText}</a></li>
                    <li><a href={`/${PageLinks.buyProperty}/`}>Property services {areaText}</a></li>
                    <li><a href={`/${PageLinks.valuation}/`}>Property valuation {areaText}</a></li>
                </ul>
            </Col>
        </div>
    )
}

export default ResidentialPopularSearch